export default [{
  path: '/portal-clientes',
  component: {
    name: 'selecionarEmpresaBase',
    template: '<router-view />',
    meta: {
      resource: 'selecionarempesaex',
      action: 'auditar',
      requiredAuth: true,
    },
  },
  children: [{
    path: 'selecionar-empresa',
    name: 'selecionar-empresa',
    component: () => import('@/app-modulo/documento/selecionar-empresa-externo/SelecionarEmpresaExterno.vue'),
    meta: {
      resource: 'selecionarempex',
      action: 'auditar',
      requiredAuth: true,
    },
  }],
}]
